import { dataFormat2 } from "../../../functions/dataFormat";
import { handleFocus, handleBlur } from "../../../functions/utilities";

const WodaOdczytyRazemSzczegolyEdytujWmP = props => {

    const { edytowanyZakres, setEdytowanyZakres } = props;

    const handleP = e => setEdytowanyZakres( prevState => ({...prevState, okres_poczatek: e.target.value}) );
    const handleWzp = e => setEdytowanyZakres( prevState => ({...prevState, zimna_stan_poczatek: e.target.value}) );
    const handleWcp = e => setEdytowanyZakres( prevState => ({...prevState, ciepla_stan_poczatek: e.target.value}) );

    return (
        <div className="row">
            <div>
                <label htmlFor="p">
                    Początek:
                </label>
                <input 
                    type="date"    
                    id="p"
                    value={dataFormat2(edytowanyZakres?.okres_poczatek)}
                    onChange={handleP}
                />
            </div>
            <div>
                <label htmlFor="wzp">
                    Stan w. zimnej:
                </label>
                <input 
                    type="number" 
                    id="wzp" 
                    value={edytowanyZakres?.zimna_stan_poczatek}
                    onChange={handleWzp}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
            <div>
                <label htmlFor="wcp">
                    Stan w. ciepłej:
                </label>
                <input 
                    type="number" 
                    id="wcp" 
                    value={edytowanyZakres?.ciepla_stan_poczatek}
                    onChange={handleWcp}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyEdytujWmP;